module.exports = __webpack_public_path__ + "img/gnxcl.9835246.png";